import React, { Component } from "react";
import InputFactory from "../../../components/InputFactory";
import CardView from "../../../components/common/CardView";
import { FloatingForm } from "../../../components/common/Converter";

export default class InputRow extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <FloatingForm width="30rem">
          <CardView style={{ padding: 0 }}>
            <h6 className="fw-bold pt-3 ps-3">Add Row</h6>
            <hr />
            <form
              onSubmit={(e) => {
                e.preventDefault();
                this.props.handleAddData();
              }}
            >
              <div className="ps-4 pe-5 pb-4">
                {this.props.inputField.map((label, index) => (
                  <div key={index} className="pb-4">
                    <label className="mb-2 fs-6">
                      {label === "Output"
                        ? "Major Final Output"
                        : label === "Distribution"
                        ? "Distribution %"
                        : label}{" "}
                      {label === "Allotted Budget" ? (
                        ""
                      ) : (
                        <span className="text-danger">*</span>
                      )}
                    </label>
                    {label === "Allotted Budget" ? (
                      <InputFactory
                        // required
                        type="Number"
                        field={label.toLowerCase().replace(" ", "")}
                        defaultValue={
                          this.props.primaryObject[
                            label.toLowerCase().replace(" ", "")
                          ]
                        }
                        onChange={(value) =>
                          this.props.handleChange(
                            label.toLowerCase().replace(" ", ""),
                            value
                          )
                        }
                      />
                    ) : (
                      <InputFactory
                        required
                        type={
                          label === "Success Indicators" ||
                          label === "Actual Accomplishments"
                            ? "textArea"
                            : label === "Distribution"
                            ? "DecemalNum"
                            : "String"
                        }
                        field={label.toLowerCase().replace(" ", "")}
                        // defaultValue={
                        //   this.state[label.toLowerCase().replace(" ", "")]
                        // }
                        value={
                          this.props.primaryObject[
                            label.toLowerCase().replace(" ", "")
                          ]
                        }
                        onChange={(value) =>
                          this.props.handleChange(
                            label.toLowerCase().replace(" ", ""),
                            value
                          )
                        }
                      />
                    )}
                  </div>
                ))}

                <p>
                  Rating{" "}
                  <i
                    className="bi bi-info-circle-fill"
                    onClick={() => this.props.handleRatingClick()}
                    style={{ cursor: "pointer" }}
                  />
                </p>
                <div className="row">
                  {this.props.ratings.map((label, index) => (
                    <div key={index} className="col-lg-4">
                      <label className="mb-2 fs-6">
                        {label}
                        {/* <span className="text-danger">*</span> */}
                      </label>
                      <InputFactory
                        // required
                        type="DecemalNum"
                        field={label.toLowerCase()}
                        value={
                          this.props.primaryObject[label.toLocaleLowerCase()]
                        }
                        placeholder={label}
                        onChange={(value) =>
                          this.props.handleRatingChange(
                            label.toLowerCase(),
                            value
                          )
                        }
                      />
                    </div>
                  ))}
                </div>

                <div className="mt-4">
                  <label className="mb-2 fs-6">Remarks</label>
                  <InputFactory
                    type="textArea"
                    field="remarks"
                    value={this.props.primaryObject.remarks}
                    // object={object}
                    onChange={this.props.handleRemarksChange}
                  />
                </div>
              </div>
              <hr />
              <div className="d-flex justify-content-end pb-3 gap-3">
                <button
                  type="button"
                  className="btn btn-light fs-sm"
                  onClick={() => this.props.handleCloseRow()}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary me-3"
                  // onClick={() => this.props.handleAddData()}
                  type="submit"
                >
                  Add
                </button>
              </div>
            </form>
          </CardView>
        </FloatingForm>
      </>
    );
  }
}
